// extracted by mini-css-extract-plugin
export default {"container":"PrivateEvents_container__JiAqX"};